import { type PropsWithChildren } from 'react';
import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { setReferrer } from '@/shared/features/enter-referrer-tracking';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
import { Videos } from './Videos';
export const Cta = () => {
  return <section className={cn('flex flex-col items-center bg-gradient-to-b from-white to-gray-100', 'pt-2xl pb-lg px-[16px] min-[751px]:pt-3xl min-[751px]:pb-2xl min-[751px]:px-[24px] min-[1025px]:pb-4xl min-[1025px]:px-[40px]')} data-sentry-component="Cta" data-sentry-source-file="Cta.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="Cta.tsx" />
      <Buttons data-sentry-element="Buttons" data-sentry-source-file="Cta.tsx" />
      <Videos data-sentry-element="Videos" data-sentry-source-file="Cta.tsx" />
    </section>;
};
const Title = () => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <h1 className="flex flex-col items-center text-center text-display-md-extrabold" data-sentry-component="Title" data-sentry-source-file="Cta.tsx">
      <p>
        <Trans t={t} i18nKey="landingV2.cta.title" components={{
        Strong: <StrongText />,
        Br: <br className="min-[751px]:hidden" />
      }} data-sentry-element="Trans" data-sentry-source-file="Cta.tsx" />
      </p>
    </h1>;
};
export const StrongText = ({
  children
}: PropsWithChildren) => <strong className="text-primary" data-sentry-component="StrongText" data-sentry-source-file="Cta.tsx">{children}</strong>;
const Buttons = () => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <div className="mb-2xl mt-[30px] flex items-center gap-2xs" data-sentry-component="Buttons" data-sentry-source-file="Cta.tsx">
      <Button variant="outlined" intent="alternative" size="lg" rounded="default" asChild data-sentry-element="Button" data-sentry-source-file="Cta.tsx">
        <Link href="/pricing" data-sentry-element="Link" data-sentry-source-file="Cta.tsx">{t('landing.cta.introduceInquiry')}</Link>
      </Button>
      <Button variant="contained" intent="strong" size="lg" rounded="default" asChild={true} data-sentry-element="Button" data-sentry-source-file="Cta.tsx">
        <Link href="/build" onClick={() => {
        setReferrer({
          from: '/landing',
          location: 'home_cta'
        });
        logger.track('enter_create', {
          location: 'home'
        });
      }} prefetch={false} data-sentry-element="Link" data-sentry-source-file="Cta.tsx">
          {t('landing.cta.createQuiz')}
        </Link>
      </Button>
    </div>;
};